import React from 'react'
import { useSelector } from 'react-redux'

export default function useRaise(tempTableId) {
    const minRaiseAmount = useSelector((state) => state.gameTable.games[tempTableId].minRaiseAmount);
    const maxRaiseAmount = useSelector((state) => state.gameTable.games[tempTableId].maxRaiseAmount);
    const atTableAmount = useSelector((state) => state.gameTable.games[tempTableId].atTableAmount);
    const bigBlind = useSelector((state) => state.gameTable.games[tempTableId]?.gameDefinition.bigBlind);
    const smallBlind = useSelector((state) => state.gameTable.games[tempTableId]?.gameDefinition.smallBlind);
    const totalPotAmount = useSelector(
        (state) => state.gameTable.games[tempTableId].totalPotAmt
    );

    return {
        minRaiseAmount,
        maxRaiseAmount,
        atTableAmount,
        bigBlind,
        smallBlind,
        totalPotAmount
    }
}
